import { EmbeddedHelper } from "Agile/Scripts/Common/EmbeddedHelper";
import CustomerIntelligenceConstants = require("Agile/Scripts/Common/CustomerIntelligence");
import Telemetry = require("VSS/Telemetry/Services");

export function PublishAutoRefreshTelemetry(eventType: string, teamId: string, ciData: IDictionaryStringTo<any>, immediate: boolean = false): void {
    ciData["EventType"] = eventType;
    ciData["TeamId"] = teamId;
    ciData["IsEmbedded"] = EmbeddedHelper.isEmbedded();
    Telemetry.publishEvent(
        new Telemetry.TelemetryEventData(
            CustomerIntelligenceConstants.AgileCustomerIntelligenceArea.AGILE,
            CustomerIntelligenceConstants.AgileCustomerIntelligenceFeature.TASKBOARD_AUTOREFRESH,
            ciData
        ),
        immediate
    );
}
